import React, {useContext} from "react";
import { Link, withRouter, useHistory } from "react-router-dom";
import {withTranslation} from "react-i18next";
import { Menu } from "antd";
import Icon from "@ant-design/icons";
import {AppContext} from "../App";
import {menuRoutes} from "../../routing/menuRoutes";
const { SubMenu } = Menu;

const MenuContainer = () => {
  const appData = useContext(AppContext);

  const visibleRoutes = appData.menuRoutes.filter(route => !route.hideFromMenu);

  return (
    <Menu
      theme="dark"
      style={{ backgroundColor: "#323234" }}
      mode="inline"
      selectedKeys={[useHistory().location.pathname]}
    >
      {visibleRoutes.map((e, i) => (
        <SubMenu
          key={`menu1${i}`}
          title={
            <Link to={e.path}>
              {e.icon && <Icon type={e.icon} style={{ marginRight: 10 }} />}
              {e.name}
            </Link>
          }
        >
          {e.routes.map((f, j) => {
            if (!f.sub) {
              return (
                <Menu.Item key={f.path}>
                  <Link to={f.path} id={`submenu${f.id}`}>
                    {f.name}
                  </Link>
                </Menu.Item>
              );
            } else {
              return (
                <SubMenu
                  key={`menu${j}`}
                  title={
                    <Link to={f.path}>
                      {f.icon && <Icon type={f.icon} style={{ marginRight: 10 }} />}
                      {f.name}
                    </Link>
                  }
                >
                  {f.sub.map((x, c) => (
                    <Menu.Item key={x.path}>
                      <Link to={x.path} id={`submenu${x.id}`}>
                        {x.name}
                      </Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              );
            }
          })}
        </SubMenu>
      ))}
    </Menu>
  );
};

export default withRouter(withTranslation('labels', { wait: true })(MenuContainer));
